import { fg } from '@atlassian/jira-feature-gating';

/**
 * Returns true when the SSR jsm-chat-ops entitlement resource should be preloaded
 * on the JSM Issue View route.
 *
 * Shared by `browseIssueRouteEntry` and `browseIssueEmbedRouteEntry` so MS Teams,
 * Zoom and Slack SSR rollouts can each opt-in independently while the resource
 * is only registered once per route (no duplicate fetches).
 *
 */
export const isJsmChatOpsEntitlementResourceEnabled = (): boolean =>
	fg('fg-perf-jsm-issue-view-optimize-ms-teams') ||
	fg('fg-perf-jsm-issue-view-optimize-zoom') ||
	fg('fg-perf-jsm-issue-view-optimize-slack');
